import EzController from 'controllers/ez-base-controller';
import { isScrolledIntoView } from 'lib/helpers';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';

export default class NativeAdController extends EzController {
  adTimeout = null;

  static targets = ['nativeTextAd', 'nativeImageAd']

  connect() {
    if (this.nativeTextAdTarget.dataset.country === 'GB') {
      this.checkGdprConsent();
    }
    this.handleRegion();
    this.nativeTextAdViewed();
    this.nativeImageAdViewed();
  }

  checkGdprConsent() {
    const resource = document.querySelector('[data-resource-ias]');
    const textAd = this.nativeTextAdTarget;
    const imageAd = this.nativeImageAdTarget;
    const makeTracker = (type) => {
      const tracker = new Image();
      tracker.src = type;
      tracker.className = 'ez-resource-show__native-text-ad__pixel';
      return tracker;
    };

    const makeAdSafeScript = (src) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = src;
      return script;
    };

    // Run this in an interval (every 0.1s) just in case we are still waiting for consent
    let cnt = 0;

    const consentSetInterval = setInterval(() => {
      cnt += 1;
      // Bail if we have not gotten a consent response after 60 seconds.
      if (cnt === 600) clearInterval(consentSetInterval);

      // Check if window.__tcfapi has been set
      if (typeof window.__tcfapi !== 'undefined') {
        clearInterval(consentSetInterval);

        /* eslint no-underscore-dangle: ["error", { "allow": ["__tcfapi",] }] */
        window.__tcfapi('addEventListener', 2, (tcData, listenerSuccess) => {
          if (listenerSuccess) {
            window.__tcfapi('removeEventListener', 2, () => { /* do nothing */ }, tcData.listenerId);

            if (tcData.eventStatus === 'tcloaded' || tcData.eventStatus === 'useractioncomplete') {
              const { consents } = tcData.purpose;

              if (consents[1] && consents[2] && consents[7]) {
                textAd.parentNode.prepend(makeTracker(resource.dataset.resourceIas));
                textAd.parentNode.prepend(makeTracker(resource.dataset.resourcePixel));
                textAd.parentNode.prepend(makeAdSafeScript(resource.dataset.resourceAdsafeJs));
                imageAd.parentNode.prepend(makeTracker(resource.dataset.resourceIas));
                imageAd.parentNode.prepend(makeTracker(resource.dataset.resourcePixel));
                imageAd.parentNode.prepend(makeAdSafeScript(resource.dataset.resourceAdsafeJs));
                textAd.parentNode.removeChild(resource);
              } else {
                textAd.parentNode.removeChild(resource);
              }
            }
          }
        });
      }
    }, 100);
  }

  handleRegion() {
    const regionList = {
      US: 'United States',
      CA: 'Canada',
      GB: 'United Kingdom',
      AU: 'Australia',
    };
    this.currentRegion = regionList[this.nativeTextAdTarget.dataset.country];
  }

  nativeTextAdViewed() {
    if (isScrolledIntoView(this.nativeTextAdTarget)) {
      sendTrackingEvent({
        data: {
          action: 'native_text_ad_view',
          category: 'native_ad',
          label: this.nativeTextAdTarget.dataset.partner,
          value: this.nativeTextAdTarget.dataset.version.toString(),
          country: this.currentRegion,
          non_interaction: true,
        },
      });

      if (this.adTimeout) clearTimeout(this.adTimeout);
    } else {
      this.adTimeout = setTimeout(() => {
        this.nativeTextAdViewed();
      }, 250);
    }
  }

  nativeTextAd = () => {
    sendTrackingEvent({
      data: {
        action: 'native_text_ad_view',
        category: 'native_ad',
        label: this.nativeTextAdTarget.dataset.partner,
        value: this.nativeTextAdTarget.dataset.version.toString(),
        country: this.currentRegion,
        non_interaction: true,
      },
    });
  }

  nativeImageAdViewed() {
    if (isScrolledIntoView(this.nativeImageAdTarget)) {
      sendTrackingEvent({
        data: {
          action: 'native_image_ad_view',
          category: 'native_ad',
          label: this.nativeTextAdTarget.dataset.partner,
          value: this.nativeTextAdTarget.dataset.version.toString(),
          country: this.currentRegion,
          non_interaction: true,
        },
      });

      if (this.adTimeout) clearTimeout(this.adTimeout);
    } else {
      this.adTimeout = setTimeout(() => {
        this.nativeImageAdViewed();
      }, 250);
    }
  }

  nativeImageAd = () => {
    sendTrackingEvent({
      data: {
        action: 'native_image_ad_click',
        category: 'native_ad',
        label: this.nativeTextAdTarget.dataset.partner,
        value: this.nativeTextAdTarget.dataset.version.toString(),
        country: this.currentRegion,
        non_interaction: true,
      },
    });
  }
}
